<template>
  <section id="content-expenses">
    <h2>Expense Breakdown</h2>

    <div class="info-grid header">
      <div class="info-item-group list">
        <img src="./assets/register.svg" />
        <label>Total Overhead</label>
        <span>{{ totalOverhead | currency }}</span>
      </div>

      <div class="info-item-group list">
        <div class="placeholder" />
        <label>% of Revenue</label>
        <span>{{ revenuePercent }}%</span>
      </div>
    </div>

    <div class="info-grid">
      <div class="info-item-group list">
        <img src="./assets/laurel-people.svg" />
        <label>Employee Compensation - Licensed</label>
        <span>{{ employeeCompLicensed | currency }}</span>
      </div>

      <div class="info-item-group list">
        <img src="./assets/person-star.svg" />
        <label>Employee Benefits</label>
        <span>{{ employeeBenefits | currency }}</span>
      </div>

      <div class="info-item-group list">
        <img src="./assets/employees.svg" />
        <label>Employee Compensation - Admin</label>
        <span>{{ employeeCompAdmin | currency }}</span>
      </div>

      <div class="info-item-group list">
        <img src="./assets/moneybag.svg" />
        <label>Employee Only Payroll Taxes</label>
        <span>{{ employeePayrollTaxes | currency }}</span>
      </div>

      <div class="info-item-group list">
        <img src="./assets/employees.svg" />
        <label>1099 Compensation - Admin</label>
        <span>{{ employeeComp1099 | currency }}</span>
      </div>

      <div class="info-item-group list">
        <img src="./assets/building.svg" />
        <label>Annual Lease / Rent (see below)</label>
        <span>{{ annualLeaseRent | currency }}</span>
      </div>

      <div class="info-item-group list">
        <img src="./assets/announce.svg" />
        <label>Advertising &amp; Marketing</label>
        <span>{{ advertising | currency }}</span>
      </div>

      <div class="info-item-group list" v-if="brokerDealer > 0">
        <img src="./assets/broker-dealer.svg" />
        <label>Broker Dealer Expenses</label>
        <span>{{ brokerDealer | currency }}</span>
      </div>

      <div class="info-item-group list">
        <img src="./assets/brain-work.svg" />
        <label>Continuing Education</label>
        <span>{{ education | currency }}</span>
      </div>

      <div class="info-item-group list">
        <img src="./assets/book-open.svg" />
        <label>Dues / Subscriptions</label>
        <span>{{ dues | currency }}</span>
      </div>

      <div class="info-item-group list">
        <img src="./assets/diploma.svg" />
        <label>Licensing Cost</label>
        <span>{{ licensing | currency }}</span>
      </div>

      <div class="info-item-group list">
        <img src="./assets/lock.svg" />
        <label>Insurance</label>
        <span>{{ insurance | currency }}</span>
      </div>

      <div class="info-item-group list" v-if="brokerDealer != null">
        <img src="./assets/broker-dealer.svg" />
        <label>Broker Dealer Expenses</label>
        <span>{{ brokerDealer | currency }}</span>
      </div>

      <div class="info-item-group list">
        <img src="./assets/paperclip.svg" />
        <label>Office Supplies</label>
        <span>{{ officeSupplies | currency }}</span>
      </div>

      <div class="info-item-group list">
        <img src="./assets/basketball.svg" />
        <label>Meals &amp; Entertainment</label>
        <span>{{ entertainment | currency }}</span>
      </div>

      <div class="info-item-group list">
        <img src="./assets/certificate.svg" />
        <label>Professional Services</label>
        <span>{{ services | currency }}</span>
      </div>

      <div class="info-item-group list" v-if="other != null">
        <img src="./assets/dots.svg" />
        <label>Other Expenses</label>
        <span>{{ other | currency }}</span>
      </div>

      <div class="info-item-group list">
        <img src="./assets/hammer.svg" />
        <label>Repairs &amp; Maintenance</label>
        <span>{{ maintenance | currency }}</span>
      </div>

      <div class="info-item-group list">
        <img src="./assets/cycle.svg" />
        <label>Referral Fee</label>
        <span>{{ referrals | currency }}</span>
      </div>

      <div class="info-item-group list">
        <img src="./assets/airplane.svg" />
        <label>Travel Normalized</label>
        <span>{{ travel | currency }}</span>
      </div>

      <div class="info-item-group list" v-if="software > 0">
        <img src="./assets/gears.svg" />
        <label>Software Costs</label>
        <span>{{ software | currency }}</span>
      </div>

      <div class="info-item-group list">
        <img src="./assets/antenna.svg" />
        <label>Utilities</label>
        <span>{{ utilities | currency }}</span>
      </div>

      <div class="info-item-group list" v-if="showBlankCell">
        &nbsp;
      </div>

    </div>

    <div v-if="notes" class="info-grid list notes">
      <div class="info-item-group pa-2" style="border: 2px dashed #97C131">
        <label>Other Notes Regarding Expenses</label>
        <span v-html="notes"></span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DetailsExpenseInformation',
  props: {
    totalOverhead: {
      type: String,
      default: '0',
    },
    revenuePercent: {
      type: String,
      default: '0',
    },
    employeeCompLicensed: {
      type: String,
      default: '0',
    },
    employeeBenefits: {
      type: String,
      default: '0',
    },
    employeeCompAdmin: {
      type: String,
      default: '0',
    },
    employeePayrollTaxes: {
      type: String,
      default: '0',
    },
    employeeComp1099: {
      type: String,
      default: '0',
    },
    annualLeaseRent: {
      type: String,
      default: '0',
    },
    advertising: {
      type: String,
      default: '0',
    },
    education: {
      type: String,
      default: '0',
    },
    brokerDealer: {
      type: String,
      default: '0',
    },
    dues: {
      type: String,
      default: '0',
    },
    licensing: {
      type: String,
      default: '0',
    },
    insurance: {
      type: String,
      default: '0',
    },
    services: {
      type: String,
      default: '',
    },
    officeSupplies: {
      type: String,
      default: '0',
    },
    entertainment: {
      type: String,
      default: '0',
    },
    other: {
      type: String,
      default: '0',
    },
    maintenance: {
      type: String,
      default: '0',
    },
    referrals: {
      type: String,
      default: '0',
    },
    travel: {
      type: String,
      default: '0',
    },
    software: {
      type: String,
      default: '0',
    },
    utilities: {
      type: String,
      default: '0',
    },
    notes: {
      type: String,
      default: 'N/A',
    },
  },

	computed: {
		showBlankCell () { 
			const number_of_expense_fields = 21       
			let showing_cnt = ( this.other == null || 0 ) +
				( this.brokerDealer == null || 0 )

			return (number_of_expense_fields-showing_cnt) % 2 === 1 ?  true : false
   		},
  	}
}
</script>

<style scoped>
label {
  font-size: 16px !important;
  line-height: 18px !important;
  align-self: flex-end;
}

.header {
  background-color: #EFEFEF !important;
}

.header .placeholder {
  width: 45px;
  grid-row-start: 1;
  grid-row-end: 3;
}

.header label {
  font-size: 22px !important;
  line-height: 24px !important;
}

.header span {
  font-family: "Sansation", sans-serif !important;
  font-size: 22px !important;
  line-height: 24px !important;
}

.notes,
.notes .info-item-group {
  grid-template-columns: auto !important;
  background-color: #EFEFEF;
}
</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details/full-details-content/ExpenseInformation.vue